import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import MovieSection from "../Components/MovieSection";

function LandingPage() {
  return (
    <>
      {/* <Header /> */}
      <MovieSection />
      {/* <Footer /> */}
      {/* <MovieDetails /> */}
    </>
  );
}

export default LandingPage;
